import { INotification } from '../../../interfaces/account/notification/INotification.ts';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { INotificationDto } from '../../../response/account/getMeResponse.ts';

interface IAccountNotificationStates {
    items: INotification[];
}

const initialState: IAccountNotificationStates = {
    items: [],
};

export const accountNotificationsSlice = createSlice({
    name: 'account-notifications',
    initialState: initialState,
    reducers: {
        updateAllFromDTO: (state: IAccountNotificationStates, action: PayloadAction<INotificationDto[]>) => {
            state.items = action.payload.map((item): INotification => ({
                id: item.id,
                type: item.type,
                createdAt: item.created_at,
                isRead: item.is_read,
                target: item.target,
                title: item.title,
            }));
        },
        add: (state: IAccountNotificationStates, action: PayloadAction<INotification>) => {
            state.items = [action.payload, ...state.items];
        },
        markAsRead: (state: IAccountNotificationStates, action: PayloadAction<string>) => {
            state.items = state.items.map((item) => item.id == action.payload ? { ...item, isRead: true } : item);
        },
        delete: (state: IAccountNotificationStates, action: PayloadAction<string>) => {
            state.items = state.items.filter((item) => item.id !== action.payload);
        },
    },
});

export const accountNotificationsActions = accountNotificationsSlice.actions;
